import * as types from './mutation-types'
/* 修改 */
const mutations = {
  [types.SET_USER](state, user) {
    state.user = user
  },
  [types.SET_FAMILY](state, family) {
    state.family = family
  },
  [types.SET_FAMILY_DETAIL](state, family) {
    state.family = Object.assign(state.family, family)
  },
  [types.SET_CURRENT_CITY](state, currentCity) {
    state.currentCity = currentCity
  },
  [types.SET_CURRENT_ORG](state, currentOrg) {
    // state.currentOrg = Object.assign(state.currentOrg, currentOrg);
    state.currentOrg = currentOrg
  },
  [types.SET_CURRENT_PAC](state, currentPac) {
    // if (state.currentPac) {
    //   state.currentPac = Object.assign(state.currentPac, currentPac);
    // } else {
    state.currentPac = currentPac
    // }
  },
  [types.SET_CURRENT_ORDER](state, item) {
    state.currentOrder = item
  },
  [types.SET_CURRENT_CARD](state, item) {
    state.currentCard = item
  },
  [types.SET_INVOICE_TYPE](state, type) {
    state.invoiceType = type
  },
  // [types.SET_CURRENT_ORDER_TYPE](state, type) {
  //   state.currentOrderType = type;
  // },
  [types.SET_PACKAGE_ORG_REQS](state, arr) {
    state.packageOrReqs = arr
  },

  [types.SET_AGREE_CMB_EXPLAIN](state, status) {
    state.agreeCMBExplain = status
  },

  [types.SET_CCB_DISCOUNT](state, status) {
    state.ccbDiscount = status
  },

  [types.SET_SUB_TITLE](state, title) {
    state.subTitle = title
  },

  [types.SET_NEW_MESSAGE_PROMPT](state, newMessagePrompt) {
    state.newMessagePrompt = newMessagePrompt
  },

  [types.SET_COMEFROM](state, comefrom) {
    state.comefrom = comefrom
  },
  [types.SET_PREVIEW_LIST_IMG](state, previewList) {
    state.previewList = previewList
  },
  [types.SET_DEFAULT_FORM_DATA](state, value) {
    state.defaultFormData = value
  },
}

export default mutations
